module.exports = __webpack_public_path__ + "img/hagrids_motorcycle.fe364fcc.jpg";